import { JSX, PropsWithChildren } from 'react'
import { Box } from '@chakra-ui/react'

const Container = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <Box
      margin="0 auto"
      maxWidth={{ base: 'calc(100% - 40px)', xl: '1320px' }}
      width={{ base: 'calc(100% - 40px)', xl: '1320px' }}
    >
      {children}
    </Box>
  )
}

export default Container
